import React, { useState } from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { Link } from 'react-scroll'
import { IoCloseCircleSharp } from 'react-icons/io5'
import { FaArrowAltCircleUp } from 'react-icons/fa'
import logo from '../../img/logoBlue.png'
import LinkButton from '../items/LinkButton'
import styles from './header.module.css'

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [overlay, setOverlay] = useState(false)
  const location = useLocation()

  function openMenuBurguer() {
    setMenuOpen(true)
    setOverlay(true)
  }

  function closeMenuBurguer() {
    setMenuOpen(false)
    setOverlay(false)
  }

  const handleLinkClick = () => {
    if (location.pathname !== '/') {
      window.location.href = '/' // Redireciona para o path raiz '/'
    }
    closeMenuBurguer()
  }

  return (
    <div id="Header" className={styles.container}>
      <div className={styles.logoContainer}>
        <RouterLink to="/">
          <img src={logo} alt="Logo Riccetto Dev" className={styles.logo} />
        </RouterLink>
      </div>
      <div className={styles.navibar}>
        <ul>
          <li>
            <Link
              activeClass="active"
              to="Start"
              spy={true}
              smooth={true}
              offset={-50}
              duration={500}
              onClick={handleLinkClick}
            >
              Inicio
            </Link>
          </li>
          <li>
            <Link
              activeClass="active"
              to="Specialty"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
              onClick={handleLinkClick}
            >
              Especialidades
            </Link>
          </li>
          <li>
            <Link
              activeClass="active"
              to="About"
              spy={true}
              smooth={true}
              offset={-50}
              duration={500}
              onClick={handleLinkClick}
            >
              Sobre
            </Link>
          </li>
          <li>
            <Link
              activeClass="active"
              to="Projects"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
              onClick={handleLinkClick}
            >
              Projetos
            </Link>
          </li>
        </ul>
      </div>
      <div className={styles.btn}>
        <Link
          activeClass="active"
          to="Contact"
          spy={true}
          smooth={true}
          offset={50}
          duration={500}
          onClick={handleLinkClick}
        >
          <LinkButton text="Contato" href="/contact" />
        </Link>
      </div>
      <div className={styles.burguerMenu}>
        <button onClick={openMenuBurguer}>
          <div className={styles.line}></div>
          <div className={styles.line}></div>
          <div className={styles.line}></div>
        </button>
      </div>
      <div className={menuOpen ? styles.menuMobileActive : styles.menuMobile}>
        <button onClick={closeMenuBurguer} className={styles.btnFechar}>
          <IoCloseCircleSharp color="#00d9ff" size={38} />
        </button>
        <div>
          <ul>
            <li>
              <Link
                activeClass="active"
                to="Start"
                spy={true}
                smooth={true}
                offset={-50}
                duration={500}
                onClick={handleLinkClick}
              >
                Inicio
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="Specialty"
                spy={true}
                smooth={true}
                offset={-50}
                duration={500}
                onClick={handleLinkClick}
              >
                Especialidades
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="About"
                spy={true}
                smooth={true}
                offset={-50}
                duration={500}
                onClick={handleLinkClick}
              >
                Sobre
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="Projects"
                spy={true}
                smooth={true}
                offset={-50}
                duration={500}
                onClick={handleLinkClick}
              >
                Projetos
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="Contact"
                spy={true}
                smooth={true}
                offset={-50}
                duration={500}
                onClick={handleLinkClick}
              >
                Contato
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div
        className={overlay ? styles.overlayMenuActive : styles.overlayMenu}
      ></div>
      <Link
        activeClass="active"
        to="Header"
        spy={true}
        smooth={true}
        offset={-50}
        duration={500}
        onClick={handleLinkClick}
        className={styles.top}
      >
        <FaArrowAltCircleUp size={38} color="#00d9ff" />
      </Link>
    </div>
  )
}
